export default "__VITE_ASSET__J4ndc1bn__"